import { useState, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";

/* Styles */
import styles from 'styles/login.module.scss';
import industryCardsStyles from 'styles/industry-cards.module.scss';
import layoutStyles from 'styles/layout.module.scss';
import onboardingStyles from 'styles/onboarding.module.scss';
import cn from 'classnames';

/* i18n */
import { useIntl } from 'react-intl';

/* API */
import { postProfile } from 'lib/API';

/* Assets */
import ArrowRight from 'assets/images/Arrow_RightLight.svg';
import IllustrationGears from 'assets/images/Illustration_Gears.svg';
import IllustrationArchery from 'assets/images/Illustration_Archery.svg';
import IllustrationResume from 'assets/images/Illustration_Resume.svg';

/* Material UI and other UI Dependencies */
import Typography from "@material-ui/core/Typography";
import OnboardingSteps from 'components/OnboardingSteps';
import { Box } from "@material-ui/core";
import IndustryCard from 'components/IndustryCard';

/* Analytics */
import { trackEvent } from 'lib/analytics';

export default function OnboardingIndustry() {
  const [industries, setIndustries] = useState([]);

  const intl = useIntl();
  const urlPrefix = intl.locale === 'en' ? '' : `/${intl.locale}`;
  const history = useHistory();

  const handleCardClick = (code) =>  {
    trackEvent('ONBOARDING_INDUSTRYTYPE', code);
    let values = {
      action: 'industry',
      naics2_code: code
    };
    postProfile(values).then(function(){
      history.push(`${urlPrefix}/onboarding/experience`);
    })
  }

  useEffect(() => {
    setIndustries(
      [
        {code: '72', title: intl.formatMessage({id:'forms.onboarding.industry.naics72', description:'string'})},
        {code: '56', title: intl.formatMessage({id:'forms.onboarding.industry.naics56', description:'string'})},
        {code: '11', title: intl.formatMessage({id:'forms.onboarding.industry.naics11', description:'string'})},
        {code: '71', title: intl.formatMessage({id:'forms.onboarding.industry.naics71', description:'string'})},
        {code: '23', title: intl.formatMessage({id:'forms.onboarding.industry.naics23', description:'string'})},
        {code: '61', title: intl.formatMessage({id:'forms.onboarding.industry.naics61', description:'string'})},
        {code: '52', title: intl.formatMessage({id:'forms.onboarding.industry.naics52', description:'string'})},
        {code: '62', title: intl.formatMessage({id:'forms.onboarding.industry.naics62', description:'string'})},
        {code: '51', title: intl.formatMessage({id:'forms.onboarding.industry.naics51', description:'string'})},
        {code: '55', title: intl.formatMessage({id:'forms.onboarding.industry.naics55', description:'string'})},
        {code: '31', title: intl.formatMessage({id:'forms.onboarding.industry.naics31', description:'string'})},
        {code: '21', title: intl.formatMessage({id:'forms.onboarding.industry.naics21', description:'string'})},
        {code: '81', title: intl.formatMessage({id:'forms.onboarding.industry.naics81', description:'string'})},
        {code: '54', title: intl.formatMessage({id:'forms.onboarding.industry.naics54', description:'string'})},
        {code: '92', title: intl.formatMessage({id:'forms.onboarding.industry.naics92', description:'string'})},
        {code: '53', title: intl.formatMessage({id:'forms.onboarding.industry.naics53', description:'string'})},
        {code: '44', title: intl.formatMessage({id:'forms.onboarding.industry.naics44', description:'string'})},
        {code: '48', title: intl.formatMessage({id:'forms.onboarding.industry.naics48', description:'string'})},
        {code: '22', title: intl.formatMessage({id:'forms.onboarding.industry.naics22', description:'string'})},
        {code: '42', title: intl.formatMessage({id:'forms.onboarding.industry.naics42', description:'string'})},
        {code: '', title: intl.formatMessage({id:'forms.onboarding.industry.unknown', description:'string'})},
      ]
    );
  }, []);

  return (
    <>
      <div className={styles.loginFlow__form__onboarding}>
        <Box px={3}>
          <Typography align="center" variant="h1"  gutterBottom>
            {intl.formatMessage({id:'onboarding.resume.title',description:'string'})}
          </Typography>
        </Box>        
        <OnboardingSteps activeStep={1} />
      </div>
      <hr className={layoutStyles.separatorBold} />
      <div className={onboardingStyles.industryStepContainer}>
        <div className={onboardingStyles.industryImagesContainer}>
          <div className={onboardingStyles.imageContainer}>
            <img alt="Resume" className={cn(onboardingStyles.imageResume)} src={IllustrationResume} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.weTake',description:'string'})}
              </Typography>
            </div>
          </div>
          <img alt="Arrow" className={cn(onboardingStyles.imageArrow)} src={ArrowRight} />
          <div className={onboardingStyles.imageContainer}>
            <img alt="Gears" className={cn(onboardingStyles.imageGears)} src={IllustrationGears} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.analyze',description:'string'})}
              </Typography>
            </div>
          </div>
          <img alt="Arrow" className={cn(onboardingStyles.imageArrow)} src={ArrowRight} />
          <div className={onboardingStyles.imageContainer}>
            <img alt="Archery" className={cn(onboardingStyles.imageArchery)} src={IllustrationArchery} />
            <div className={onboardingStyles.imageTextContainer}>
              <Typography align="center" variant="caption"  gutterBottom>
                {intl.formatMessage({id:'onboarding.resume.generateRecommendations',description:'string'})}
              </Typography>
            </div>

          </div>
        </div>
        <div className={onboardingStyles.industryLinkContainer}>
          <Typography align="center" variant="body1">
            {intl.formatMessage({id:'onboarding.resume.haveResume',description:'string'})}
          </Typography>
          <Link to={`${urlPrefix}/onboarding/resume-upload`} className={cn(layoutStyles.link, onboardingStyles.enterInfoLink)}>
            {intl.formatMessage({id:'onboarding.resume.uploadIt',description:'string'})}
          </Link>
        </div>
        <div className={onboardingStyles.resumeFullTextContainer}>
          <Typography align="center" variant="caption"  gutterBottom>
            {intl.formatMessage({id:'onboarding.resume.fullText',description:'string'})}
          </Typography>
        </div>
        <div className={onboardingStyles.cardsContainer}>
          <Typography align="center" variant="h3" component="h2" gutterBottom>
            {intl.formatMessage({id:'onboarding.industry.label',description:'string'})}
          </Typography>
          <div className={industryCardsStyles.container}>
            {industries.map(i => (
              <IndustryCard text={i.title} code={i.code} key={i.code} onClick={handleCardClick} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}